
<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-xl-6">
            <div class="card-box">
                <div class="Chart">
                    <canvas id="orders" width="50" height="50"></canvas>
                </div>
            </div>
            <div v-if="total && total > 0" style="font-size:15px; text-align:center;">
                <label>Total:</label> {{total}}
            </div>
        </div>
    </div>
</template>
            
<script>
import Chart from 'chart.js';
import Controller from './CrtOrders';
export default {
  
    name: 'Pedidos',
    components: {
    },
    
    data() {
    return {
        chart: null,
        total: 0,
        company: null,
      }
    },
    methods: Controller.methods,
    created() {
      Controller.init(this);
    },
    mounted() {

        const ctx = document.getElementById('orders');
        this.chart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            datasets: [{ 
                    data: null,
                    backgroundColor: ["#EBCB38","#C13018","#063951"],
                }],
                labels: ['Certificados', 'Serviços', 'Peças'],
        },
        options: { 
            /*responsive: true,
            events: false,
            tooltips: {
                enabled: false
            },
            hover: {
                animationDuration: 0
            },*/
            title: {
                display: true, 
            },
            legend: {
                fullWidth: true,
                labels: {
                    fontColor: '#000',
                    boxWidth: 20, 
                }
            },
            /*animation: {
                onComplete: function () {
                    var chartInstance = this.chart,
                    ctx = chartInstance.ctx;
                    ctx.font = Chart.helpers.fontString(25, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'center';

                    this.data.datasets.forEach(function (dataset, i) {
                        var meta = chartInstance.controller.getDatasetMeta(i);
                        meta.data.forEach(function (bar, index) {
                            var data = dataset.data[index];
                            ctx.fillText(data, bar._model.x, bar._model.y - 5);
                        });
                    });
                }
            }*/
        }
      });
      this.filter();
    }
}
    

</script>
